import React, { useId } from 'react';

export interface PuAiStarProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function PuAiStar({ size = 16, className, style }: PuAiStarProps) {
  const id = useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      style={{ flex: 'none', ...style }}
      aria-hidden
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--ai-3)" />
          <stop offset="52%" stopColor="var(--ai-4)" />
          <stop offset="100%" stopColor="var(--ai-5)" />
        </linearGradient>
      </defs>
      <path
        d="M12 2 L13.6 9.4 L21 12 L13.6 14.6 L12 22 L10.4 14.6 L3 12 L10.4 9.4 Z"
        fill={`url(#${id})`}
      />
    </svg>
  );
}
